<div class="tw-text-center tw-text-muted">
  <p bitTypography="body2" class="tw-mb-0"></p>
</div>
